import { render } from "./AppLayout.vue?vue&type=template&id=3952b574"
const script = {}

import "./AppLayout.vue?vue&type=style&index=0&id=3952b574&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__